import { Vue, Component, Prop, Provide, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
	name: "LoadingScreen"
})
export default class LoadingScreenComponent extends Vue {
	@Getter("state/getLoading") private isLoading!: boolean;
}
